import { LogoutOutlined, KeyOutlined } from '@mui/icons-material';
import { FormControl, MenuItem, Typography } from '@mui/material';
import { accountsAtom, tokenAtom } from 'atoms';
import AccountAvatar from 'components/AccountAvatar';
import TopBarSelect from 'components/TopBarSelect';
import { useLogout } from 'hooks';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

function UserOptions() {
  const { handleLogout } = useLogout();
  const navigate = useNavigate();
  const accounts = useRecoilValue(accountsAtom);
  const token = useRecoilValue(tokenAtom);

  const firstAccount = accounts?.[0];

  const OPTIONS = [
    {
      title: 'Alterar senha',
      icon: KeyOutlined,
      onClick: () => {
        navigate('/change-login-password', {
          state: {
            token,
            email: firstAccount?.email,
            masterCompanyId: firstAccount?.masterCompanyId,
          },
        });
      },
    },
    {
      title: 'Logout',
      icon: LogoutOutlined,
      onClick: handleLogout,
    },
  ];

  return (
    <FormControl>
      <TopBarSelect
        id="user-options"
        aria-label="User options"
        label="Opções"
        value
        onChange={() => {}}
        renderValue={() => (
          <AccountAvatar
            image={firstAccount?.custom?.image}
            selectedColor={firstAccount?.custom?.color}
            accountName={firstAccount?.displayName || ''}
            size={35}
          />
        )}
      >
        {OPTIONS.map(({ icon: Icon, title, onClick }) => (
          <MenuItem key={title} onClick={onClick} autoFocus={false}>
            <Icon />
            <Typography variant="body2" sx={{ ml: 1.5 }}>
              {title}
            </Typography>
          </MenuItem>
        ))}
      </TopBarSelect>
    </FormControl>
  );
}

export default UserOptions;
